import React, { useState } from 'react';

export default function ContactForm() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    enquiryAbout: "",
    mobile: "",
    message: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
    const [errors, setErrors] = useState({
    name: "",
    email: "",
    mobile: "",
  });
  const handleChange = (e) => {
  const { name, value } = e.target;

  setFormData((prev) => ({
    ...prev,
    [name]: value,
  }));

  let error = "";

  switch (name) {
    case "name":
      if (!/^[A-Za-z\s]*$/.test(value)) {
        error = "Name can only contain letters and spaces.";
      }
      break;

    case "email":
      if (
        value &&
        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value)
      ) {
        error = "Please enter a valid email address.";
      }
      break;

    case "mobile":
      if (!/^\d*$/.test(value)) {
        error = "Mobile number can contain digits only.";
      } else if (value.length > 15) {
        error = "Maximum 15 digits allowed.";
      }
      break;

    default:
      break;
  }

  setErrors((prev) => ({
    ...prev,
    [name]: error,
  }));
};

  const handleSubmit = async (e) => {
  e.preventDefault();

  if (!formData.name.trim()) {
    alert("Please enter your name");
    return;
  }
  if (!formData.mobile.trim()) {
    alert("Please enter your mobile number");
    return;
  }

  setIsSubmitting(true);

  try {
    const payload = {
      formType: "contact",   // <-- add this
      ...formData,
    };

    const response = await fetch(
      "https://script.google.com/macros/s/AKfycbzUGA8MX-C5Y4M8iXBaKg8t2R-tJmrHw6-9mT5uNRi-POMNA5qKjZ2BpNOXQCWVQR4M/exec",
      {
        method: "POST",
        body: JSON.stringify(payload),
      }
    );

    const text = await response.text();
    console.log("RAW RESPONSE:", text);

    const result = JSON.parse(text);

    if (result.success) {
      alert("Message sent successfully");
      setFormData({ name: "", email: "", enquiryAbout: "", mobile: "", message: "" });
    } else {
      alert("Submission failed: " + result.error);
    }
  } catch (error) {
    console.error("Network/CORS error:", error);
    alert("Submission failed — check console for details");
  } finally {
    setIsSubmitting(false);
  }
};

  return (
    <div className="cs_contact_form cs_style_1 cs_white_bg cs_radius_30"   data-aos="fade-up"
  data-aos-duration="1200"
  data-aos-offset="200"
  style={{ marginTop: "150px" }}>
      <form onSubmit={handleSubmit} className="row">
        <div className="col-lg-6">
          <label className="cs_input_label cs_heading_color">
            Name <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            className="cs_form_field"
            placeholder="David John"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
            pattern="^[A-Za-z\s]+$"
            title="Name can only contain letters and spaces."
          />
          {errors.name && (
              <small className="text-danger">{errors.name}</small>
            )}
        </div>
        <div className="col-lg-6">
          <label className="cs_input_label cs_heading_color">Email</label>
          <input
            type="email"
            className="cs_form_field"
            placeholder="example@gmail.com"
            name="email"
            value={formData.email}
            onChange={handleChange}
            
          />
          {errors.email && (
            <small className="text-danger">{errors.email}</small>
          )}
        </div>
        <div className="col-lg-6">
          <label className="cs_input_label cs_heading_color">Enquiry About <span className="text-danger">*</span></label>
          <input
            type="text"
            className="cs_form_field"
            placeholder="Your subject"
            name="enquiryAbout"
            value={formData.enquiryAbout}
            onChange={handleChange}
          />
          <div className="cs_height_42 cs_height_xl_25" />
        </div>
        <div className="col-lg-6">
          <label className="cs_input_label cs_heading_color">
            Mobile Number <span className="text-danger">*</span>
          </label>
          <input
            type="tel"
            className="cs_form_field"
            placeholder="0000000"
            name="mobile"
            value={formData.mobile}
            onChange={handleChange}
            required
            pattern="^[0-9]{7,15}$"
            title="Please enter only digits (7-15 digits)."
          />
          {errors.mobile && (
            <small className="text-danger">{errors.mobile}</small>
          )}
        </div>
        <div className="col-lg-12">
          <label className="cs_input_label cs_heading_color">Message</label>
          <textarea
            cols={30}
            rows={10}
            className="cs_form_field"
            placeholder="Write something..."
            name="message"
            value={formData.message}
            onChange={handleChange}
          />
          <div className="cs_height_42 cs_height_xl_25" />
        </div>
        <div className="col-lg-12">
          <div className="cs_height_18" />
          <button className="cs_btn cs_style_1" type="submit" disabled={isSubmitting}>
            <span>{isSubmitting ? "Sending..." : "Submit"}</span>
            <i>
              {isSubmitting ? (
                <span className="spinner" />
              ) : (
                <>
                  <img src="/images/icons/arrow_white.svg" alt="Icon" />
                  <img src="/images/icons/arrow_white.svg" alt="Icon" />
                </>
              )}
            </i>
          </button>
        </div>
      </form>
    </div>
  );
}
